import { FC } from 'react';

import { Chip, Tooltip, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import Order from '@/shared/types/order/order.type';
import formatDate from '@/shared/utils/formatDate';

type TitleProps = {
  order: Order;
};

const Title: FC<TitleProps> = ({ order }) => {
  return (
    <Stack direction='row'>
      <Stack>
        <Tooltip title={order.in_order_id} placement='right-end' arrow>
          <Typography variant='body1' sx={{ width: 'max-content' }}>
            {order.in_order_id?.split('-')[0] ?? ''}
          </Typography>
        </Tooltip>

        <Typography variant='caption' color='text.secondary'>
          {formatDate(order.ts_created ?? '')}
        </Typography>
      </Stack>

      <Stack direction='row' spacing={1} sx={{ ml: 'auto' }}>
        <Chip label={order.order_status} />
      </Stack>
    </Stack>
  );
};

export default Title;
